<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6">
        <v-card-title class="mt-4">
          <v-btn class="mr-2" fab x-small color="primary" @click="$router.back()">
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn>Add a Candidate
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete outlined ref="rank" v-model="form.rank" :items="ranks" label="Rank *"
                append-icon="mdi-account" :error-messages="errors.rank"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="4">
              <v-text-field v-model="form.name" outlined label="Given Name *" prepend-inner-icon="mdi-buffet"
                :error-messages="errors.name"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.last_name" outlined label="Surname Name *" prepend-inner-icon="mdi-buffet"
                :error-messages="errors.last_name"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.phone" outlined label="Mobile no *" prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.email" outlined label="Email *" prepend-inner-icon="mdi-email"
                :error-messages="errors.email"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.age" outlined label="Age" prepend-inner-icon="mdi-calendar"
                :error-messages="errors.age"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.contract_expiry" outlined label="Contract Expiry" prepend-inner-icon="mdi-calendar-clock"
                :error-messages="errors.contract_expiry"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field v-model="form.on_board_since" outlined label="On Board Since" prepend-inner-icon="mdi-ship-wheel"
                :error-messages="errors.on_board_since"></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete outlined ref="vessel" v-model="form.vessel_id" :items="vessels"
                item-value="id" item-text="description" label="Vessel"
                append-icon="mdi-ferry" :error-messages="errors.vessel_id"></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-checkbox v-model="form.is_pre_join" label="Pre-Join Candidate"
                hint="Only sees pre-join courses on portal login" persistent-hint>
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-card-text>
              <v-divider class="mt-5 mb-5"> </v-divider>
              <v-progress-circular style="float: right;" v-if="isLoading" indeterminate
                color="primary"></v-progress-circular>
              <v-btn style="float: right;" v-else color="primary" dark @click="save"> Save Candidate </v-btn>
            </v-card-text>

          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import UserService from "@/services/user-service";

export default {
  name: "UserCreatePage",
  data() {
    return {
      form: {
        active: true,
        is_pre_join: false,
      },
      companies: [],
      dob_menu: false,
      roles: [
        {
          id: 0,
          text: "Select Role",
          value: "",
        },
      ],
      ranks: [],
      teachers: [],
      nationalities: [],
      birth_places: [],
      vessels: [],
      courses: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      try {
        let response = await UserService.getMasters();
        let masters = response || {};
        
        // Handle ranks data
        if (masters.ranks && Array.isArray(masters.ranks)) {
          masters.ranks.forEach((rank) => {
            if (rank && rank.id && rank.description) {
              this.ranks.push({
                id: rank.id,
                text: rank.description,
                value: rank.description,
              });
            }
          });
        }

        // Handle vessels data
        if (masters.vessels && Array.isArray(masters.vessels)) {
          this.vessels = masters.vessels.map(vessel => ({
            id: vessel.id,
            description: vessel.description,
            text: vessel.description,
            value: vessel.id,
          }));
        }
        
        console.log('Candidate create: Masters data loaded - Ranks:', this.ranks.length, 'Vessels:', this.vessels.length);
      } catch (error) {
        console.error('Candidate create: Error loading masters data:', error);
        this.ranks = [];
      }
    },
    async save() {
      try {
        this.isLoading = true;
        this.form.role_id = 4;
        this.form.course_candidate = null;
        if (this.roleName == 'TEACHER') {
          this.form.assign_teacher_id = this.user.id;
        }
        
        let candidate = await UserService.createUser(this.form);
        this.candidate = candidate.data;
        this.$router.push('/users');
        this.isLoading = false;
      } catch (error) {
        console.error("Error creating candidate:", error);
        this.isLoading = false;
      }
    },
  },
};
</script>
